var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPromise2 = function SvgPromise2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 72,
    viewBox: "0 0 76 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-3h76.359v74.579H-1z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0c74c6",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.904 6.432h24.189M14.425 1.589h7.949M36.609 1.589h4.714M8.11 11.275h34.756M9.248 16.119h25.753M5.55 20.962l26.606.166M2.963 25.805h21.814M.744 31.052H13.87M1.302 35.895H13.87M.005 41.119l10.722.046M.005 46.022h8.134M2.963 50.828h20.405M10.357 56.075h24.296M8.139 60.918h30.827M7.77 65.762l31.196.011M20.34 70.201h7.765"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.685 17.128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.878 0h7.461c.201 0 .365.163.365.365v9.783a.405.405 0 0 1-.405.405h-8.417l-.666-2.862a.81.81 0 0 1-.007-.332l1.31-7.061A.365.365 0 0 1 32.88 0zM22.613 13.055l3.945-5.116a.365.365 0 0 1 .639.121l3.994 13.72h-2.173c-.118 0-.236-.02-.348-.057l-1.032-.347M29.18 13.188h2.925a.73.73 0 0 1 .706.547l1.982 7.641h5.427M22.31 12.493L21.2 9.765a.405.405 0 0 0-.605-.18l-8.973 6.172"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.844,
    cy: 21.106,
    rx: 7.163,
    ry: 7.787
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.803 11.95l-5.2 15.403H0h11.256a.365.365 0 0 0 .365-.364V14.885c0-.13-.07-.251-.183-.316l-6.12-3.527 1.485.908zM11.621 21.186l2.205-.906M40.704 6.056h2.114c5.02 0 9.985 1.037 14.585 3.045l1.753.765v4.782M56.903 14.648h3.534v5.791a.73.73 0 0 1-.73.73h-5.12"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.383,
    cy: 20.28,
    rx: 7.163,
    ry: 7.787
  }))))));
};
export default SvgPromise2;